import cx from "classnames";
import { useMemo } from "react";

import { BASIS_POINTS_DIVISOR } from "config/factors";
import {
  selectTradeboxMarketInfo,
  selectTradeboxState,
} from "context/SyntheticsStateContext/selectors/tradeboxSelectors";
import { useSelector } from "context/SyntheticsStateContext/utils";
import { getMaxAllowedLeverageByMinCollateralFactor } from "domain/synthetics/markets";
import { TradeType, TradeTypeOverview } from "sdk/types/trade";

import Chip from "components/Chip/Chip";

const TradeTypeChip = ({ className }: { className?: string }) => {
  const { tradeType } = useSelector(selectTradeboxState);
  const marketInfo = useSelector(selectTradeboxMarketInfo);

  const text = useMemo(() => {
    if (tradeType === TradeType.Swap) {
      return TradeTypeOverview.Swap;
    }
    return TradeTypeOverview.Perp;
  }, [tradeType]);

  const leverageText = useMemo(() => {
    if (tradeType === TradeType.Swap) {
      return null;
    }

    const leverage = getMaxAllowedLeverageByMinCollateralFactor(marketInfo?.minCollateralFactor) / BASIS_POINTS_DIVISOR;
    if (!Number.isFinite(leverage) || leverage <= 0) {
      return "-";
    }

    return `${leverage}x`;
  }, [marketInfo?.minCollateralFactor, tradeType]);

  return (
    <div className={cx("inline-flex items-center gap-6", className)}>
      {leverageText !== null && (
        <Chip variant="tertiary" className="!px-[11.5px] !py-[1px] md:!px-[12px] md:!py-[1.5px]">
          {leverageText}
        </Chip>
      )}
      <Chip variant="tertiary" className="!px-[11.5px] !py-[1px] md:!px-[12px] md:!py-[1.5px]">
        {text}
      </Chip>
    </div>
  );
};

export default TradeTypeChip;
